import React, { useState } from 'react';
import { IoAppsOutline } from 'react-icons/io5';

// An app's own logo (the same source Settings → Connectors uses), falling back to a
// generic icon when the app has none or the image fails to load.
const LOGO_BASE = 'https://logos.composio.dev/api/';

export const appLogoUrl = (toolkit, logo) => logo || (toolkit ? `${LOGO_BASE}${encodeURIComponent(String(toolkit).toLowerCase())}` : '');

export default function AppLogo({ toolkit, logo, size = 20, className = '' }) {
  const src = appLogoUrl(toolkit, logo);
  const [failed, setFailed] = useState(false);
  if (!src || failed) return <IoAppsOutline size={size} className={className} aria-hidden="true" />;
  return (
    <img
      src={src}
      alt=""
      width={size}
      height={size}
      className={className}
      onError={() => setFailed(true)}
      style={{ objectFit: 'contain' }}
    />
  );
}
